<template>
  <div
    id="companies-candidate"
    class="sketch-border create-profile-step-container"
  >
    <step-title
      :title="title"
      :subtitle="subtitle"
      :icon="icon"
      :help-text="helpText"
    />
    <div class="title is-6">
      <p class="has-text-grey">
        (Starting with most recent)
      </p>
    </div>
    <section class="section is-paddingless">
      <div
        v-for="(company, index) in companies"
        :key="company.key"
        class="create-profile-step-container card card-content"
      >
        <h5 class="title is-5 has-text-grey">
          Anonymous Company {{ index + 1 }}
        </h5>
        <div class="field">
          <div class="control is-expanded">
            <label class="label">Annual Revenue</label>
            <div class="select is-fullwidth is-primary">
              <select
                v-model="company.annual_revenue"
                v-validate="'required'"
                :name="`Company ${index + 1} Annual Revenue`"
                @change="updateCompanies()"
              >
                <option />
                <option>$ 0 - 1M</option>
                <option>$ 1M - 10M</option>
                <option>$ 10M - 100M</option>
                <option>$ 100M - 1B</option>
                <option>$ 1B+</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control is-expanded">
            <label class="label">Number of Employees</label>
            <div class="select is-fullwidth is-primary">
              <select
                v-model="company.number_of_employees"
                v-validate="'required'"
                :name="`Company ${index + 1} Number of Employees`"
                @change="updateCompanies()"
              >
                <option />
                <option>1 - 10</option>
                <option>10 - 100</option>
                <option>100 - 1,000</option>
                <option>1,000 - 10,000</option>
                <option>10,000+</option>
              </select>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control is-expanded">
            <label class="label">Corporate Structure</label>
            <div class="select is-fullwidth is-primary">
              <select
                v-model="company.corporate_structure"
                v-validate="'required'"
                :name="`Company ${index + 1} Corporate Structure`"
                @change="updateCompanies()"
              >
                <option />
                <option>Private</option>
                <option>Public</option>
                <option>Non-Profit</option>
                <option>Startup</option>
                <option>Government</option>
              </select>
            </div>
            <p
              v-show="errors.has(`Company ${index + 1} Corporate Structure`)"
              class="help is-danger"
            >
              {{ errors.first(`Company ${index + 1} Corporate Structure`) }}
            </p>
          </div>
        </div>
        <div class="field">
          <div class="control is-expanded">
            <label class="label">Role</label>
            <div class="select is-fullwidth is-primary">
              <select
                v-model="company.role"
                v-validate="'required'"
                :name="`Company ${index + 1} Role`"
                @change="updateCompanies()"
              >
                <option />
                <option>Individual Contributor</option>
                <option>Management</option>
                <option>Executive</option>
              </select>
            </div>
          </div>
        </div>
        <div>
          <i
            class="fas fa-times-circle"
            @click="removeCompany(index)"
          />
        </div>
      </div>
    </section>
    <div
      v-if="companies.length === 0 || isLastCompanyFilled"
      class="add-card has-text-primary"
      @click="addCompany"
    >
      <i class="fas fa-plus" />
      <small
        v-if="companies.length > 0"
        class="has-text-weight-bold"
      >&nbsp;Add Another Company</small>
      <small
        v-else
        class="has-text-weight-bold"
      >&nbsp;Add a Company</small>
    </div>
  </div>
</template>

<script>
import StepTitle from './StepTitle';

export default {
  name: 'CompaniesCandidate',
  components: {
    StepTitle
  },
  data () {
    return {
      title: 'Companies',
      subtitle: "Identify the types of companies you've worked with",
      icon: 'fa-users',
      companies: [],
      helpText: ''
    };
  },
  computed: {
    isLastCompanyFilled () {
      if (this.companies.length < 1) {
        return false;
      } else {
        let lastItem = this.companies.length - 1;
        return (
          this.companies[lastItem].annual_revenue !== ''
          && this.companies[lastItem].number_of_employees !== ''
          && this.companies[lastItem].corporate_structure !== ''
          && this.companies[lastItem].role !== ''
        );
      }
    },
    isFormValid () {
      return (
        this.companies.length > 0
        && Object.keys(this.fields).every(key => this.fields[key].valid)
      );
    }
  },
  created () {
    this.companies = this.$store.state.user.profile.companies;
  },
  mounted () {
    this.checkForm();
  },
  updated () {
    this.checkForm();
  },
  methods: {
    addCompany () {
      this.companies.push({
        annual_revenue: '',
        number_of_employees: '',
        corporate_structure: '',
        role: ''
      });
      this.updateCompanies();
    },
    removeCompany (index) {
      if (index > -1) {
        this.companies.splice(index, 1);
      }
      this.updateCompanies();
    },
    updateCompanies () {
      this.checkForm();
      this.$store.commit('EDIT_CANDIDATE_COMPANIES', this.companies);
    },
    checkForm () {
      setTimeout(() => {
        this.$emit('checkForm', this.isFormValid);
      }, 50);
    }
  }
};
</script>

<style scoped lang="scss">
.create-profile-step-container {
  margin-bottom: 1.5rem;
}

.add-card {
  cursor: pointer;
}

.card {
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(77, 101, 117, 0.25);
}

.fa-times-circle {
  position: absolute;
  right: -6px;
  top: -6px;
  cursor: pointer;
}
</style>
